import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=20561eb7&scoped=true&"
import script from "./SignupView.vue?vue&type=script&lang=js&"
export * from "./SignupView.vue?vue&type=script&lang=js&"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=20561eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20561eb7",
  null
  
)

export default component.exports